import React, { useEffect, useState } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import Icon from '@mdi/react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import * as R from 'ramda';

import { mdiWechat, mdiSinaWeibo, mdiEarth } from '@mdi/js';

import Container from './Container';
import Loading from '@components/Base/Loading';

import { fetch } from '@utils/fetch';
import { getCustomData } from '@utils/Analysis';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: [rem(10), rem(20)],
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  sign: {
    fontSize: rem(30),
    color: 'rgba(38, 38, 38, 1)',
  },
  icons: {
    width: '50%',
    '& > a': {
      color: '#FFF',
    }
  },
  icon: {
    width: 28,
    height: 28,
    padding: rem(5),
    borderRadius: '50%',
    backgroundColor: 'rgba(38, 38, 38, 1)',
  },
  line: {
    width: '100%',
    fontSize: 18,
    margin: [rem(20), 0],
    color: 'rgba(100, 100, 103, 1)',
  },
  qrBox: {
    display: 'none',
    position: 'absolute',
    bottom: 130,
    padding: 10,
    right: '30%',
    border: '1px solid #CCC',
    backgroundColor: '#FFF',
    borderRadius: 10,
  },
  loading: {
    color: '#000',
    margin: rem(15),
  },
  show: {
    display: 'block',
  }
}), {
  name: 'Footer'
})

const Footer = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { t, data } = props;

  const [isShow, setIsShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const custom = getCustomData(data);
  const social = R.pathOr({}, ['socialchannel'])(custom);
  const logoImage = R.pathOr('', ['logoimage', 'filelocation'])(custom);
  const wechat = R.pathOr('', ['wechatimage', 'filelocation'])(social);
  const wechatLink = R.pathOr('', ['wechatlink'])(social);

  const [wechatImage, setWechatImage] = useState(wechat);

  // 二维码图片有效期为1分钟
  useEffect(() => {
    if (isShow) {
      setLoading(true);
      const params = {
        types: [
          'customizedDisplayInfo',
        ],
        language: 'zh'
      };
      fetch(params).then((data) => {
        const custom = getCustomData(data);
        const social = R.pathOr({}, ['socialchannel'])(custom);
        const wechat = R.pathOr('', ['wechatimage', 'filelocation'])(social);
        setWechatImage(wechat);
        setLoading(false);
      }, (err) => {
        console.log(err, '请求二维码图片数据失败');
        setWechatImage('请求失败');
        setLoading(false);
      });
    }
  }, [isShow]);

  function isWeChat(){
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    const ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
      return true;
    }else{
      return false;
    }
  }

  const handleClickWechat = () => {
    if (isWeChat()) {
      global.window.location.href = wechatLink || 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg5OTA2MDkxMA==&scene=124#wechat_redirect'
    } else {
      setIsShow(!isShow);
    }

  }

  return (
    <footer className={classNames(classes.root)}>
      <Container
        flex
        justify='space-between'
        alignItems='center'
        style={{ width: '100%' }}
      >
        <img src={logoImage} alt="logo" width={130} />

        <Container
          flex
          justify='space-between'
          className={classes.icons}
        >
          <Icon
            path={mdiWechat}
            size={0.6}
            onClick={handleClickWechat}
            className={classNames(classes.icon)}
          />
          <a href={social.weibolink} rel='noreferrer'>
            <Icon
              path={mdiSinaWeibo}
              size={0.6}
              className={classNames(classes.icon)}
            />
          </a>
          <a href={social.homewebsite} rel='noreferrer'>
            <Icon
              path={mdiEarth}
              size={0.6}
              className={classNames(classes.icon)}
            />
          </a>
        </Container>
      </Container>

      <Container flex justify='flex-end' className={classes.line}>{t('hotline')} : {social.hotline}</Container>

      <Container
        flex
        className={classNames(classes.qrBox, isShow && classes.show)}
      >
        {
          loading ? (
            <Loading
              size={0.5}
              className={classes.loading}
            />
          ) : (
            <QRCode
              className={classNames(classes.qrCode)}
              value={wechatImage}
              size={100}
              level='M'
              bgColor='#ffffff'
              id='canvas'
            />
          )
        }
      </Container>
    </footer>
  )
};

Footer.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
}

export default Footer;
